
/**
 * Hàm convert sang dạng Base64
 * @param {} data
 */
export const convertToBase64 = (data) => {
    if (typeof data != "string") {
      data = JSON.stringify(data);
    }
    let buffer = Buffer.from(data);
    let base64 = buffer.toString("base64");
    return base64;
}

/**
 * Hàm encode 1 chuỗi thành base64
 * created by tcduong
 * created date 21/12/2020
 * ex: b64EncodeUnicode('["EmployeeName","IN","Tran Huyen"]') => "WyJFbXBsb3llZU5hbWUiLCJJTiIsIlRyYW4gSHV5ZW4iXQ=="
 * @param {Chuỗi cần convert thành base64} str
 */
export const b64EncodeUnicode = (str) => {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidBytes(
        match,
        p1
      ) {
        return String.fromCharCode("0x" + p1);
      })
    );
}

/**
 * Hàm decode base64
 * created by tcduong
 * created date 21/12/2020
 * ex: b64DecodeUnicode("WyJFbXBsb3llZU5hbWUiLCJJTiIsIlRyYW4gSHV5ZW4iXQ==") => '["EmployeeName","IN","Tran Huyen"]'
 * @param {Chuỗi cần decode} str
 */
export const b64DecodeUnicode = (str) =>  {
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
}